import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import IconTitle from 'components/resource/IconTitle'

import resourceSettings from 'settings/resources'

const {
  resources,
} = resourceSettings

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
  linkContainer: {
    cursor: 'pointer',
  },
  linkTitle: {
    textDecoration: 'underline',
    color: theme.palette.primary.main,
  },
  folderPathSplitter: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  },
}))

const FolderPathTitle = ({
  quote,
  folderPath,
  onView,
}) => {
  const classes = useStyles()

  const useFolderPath = [{
    id: 'root',
    resource: {
      name: quote.name,
    },
  }].concat(folderPath)

  return (
    <div className={ classes.root }>
      {
        useFolderPath.map((pathItem, i) => {

          let showLink = i < useFolderPath.length - 1
          return (
            <React.Fragment key={ i }>
              <Typography 
                variant="h6"
                className={ showLink ? `${ classes.linkContainer } ${ classes.linkTitle }` : '' }
                onClick={ () => {
                  if(!showLink) return
                  onView(pathItem.id)
                }}
              >
                { pathItem.resource.name }
              </Typography>
              {
                i < useFolderPath.length - 1 && (
                  <Typography 
                    variant="h6"
                    className={ classes.folderPathSplitter }
                  >
                    :
                  </Typography>
                )
              }
            </React.Fragment>
            
          )
        })
      }
    </div>
  )
}

export default FolderPathTitle

